export interface RandomBoxConfig {
  houseIds: number[];
  title: string;
  description: string;
  originalPrice: number;
  discountPrice: number;
  isNew?: boolean;
}

// Egypt box (houses 33-35) — shown at the top
export const EGYPT_BOX_CONFIG: RandomBoxConfig = {
  houseIds: [33, 34, 35],
  title: "Desert Sands Mystery Box",
  description: "A rare mystery box filled with ancient desert architecture. Contains iconic landmarks of the pharaohs' world. For those who seek power, legacy, and timeless grandeur.",
  originalPrice: 149,
  discountPrice: 99,
  isNew: true,
};

// Old Bikini Bottom box (houses 16-18) — shown in the center
export const BIKINI_BOTTOM_OLD_BOX_CONFIG: RandomBoxConfig = {
  houseIds: [16, 17, 18],
  title: "Bikini Bottom House Box",
  description: "A limited mystery box inspired by life under the sea. Contains exclusive iconic houses with bright ocean charm. Limited-time offer.",
  originalPrice: 149,
  discountPrice: 99,
};

// Houses 30-32 reserved for future box — hidden from catalog for now
const RESERVED_BOX_IDS = [30, 31, 32];

// All house IDs that belong to any box — filtered from the main catalog
export const ALL_BOX_HOUSE_IDS: number[] = [
  ...EGYPT_BOX_CONFIG.houseIds,
  ...BIKINI_BOTTOM_OLD_BOX_CONFIG.houseIds,
  ...RESERVED_BOX_IDS,
];
